<template>
    <div class="c-contestant-pagination my-5">
        <nav role="navigation" aria-label="Pagination" aria-hidden="false">
            <ul class="pagination pagination-lg pagination--page-count">
                <li class="page-item mx-2" v-if="currentPage !== 1">
                    <button type="button"
                        role="button"
                        aria-label="Previous Page"
                        tabindex="0"
                        class="page-link"
                        @click="setPreviousPage()">
                        <i class="icon-left-arrow"></i>
                        <span class="sr-only">Previous Page</span>
                    </button>
                </li>
                <li class="page-item mx-2" v-for="pageNumber in pages">
                    <button type="button" role="button" class="page-link font-weight-normal" :class="{'active': currentPage === pageNumber }"
                        tabindex="0"
                        :aria-current="`${currentPage === pageNumber && 'page'}`"
                        :aria-selected="currentPage === pageNumber ? 'true' : 'false'"
                        :aria-label="`Page ${pageNumber}`"
                        @click="setCurrentPage(pageNumber)">
                        {{pageNumber}}
                    </button>
                </li>
                <li class="page-item mx-2" v-if="currentPage !== totalPages">
                    <button type="button" role="button" tabindex="0" aria-label="Next Page" class="page-link" @click="setNextPage">
                        <i class="icon-right-arrow"></i>
                        <span class="sr-only">Next Page</span>
                    </button>
                </li>
            </ul>
            <div aria-live="polite" class="sr-only">{{  message }}</div>
		</nav>	
    </div>
</template>

<script>
export default {
    data() {
        return {
            currentPage: 0,
            totalPages: 0,
            maxVisibleButtons: 5,
            message: '',
            hasShowMessage: false,
        };
    },
    props: {
        numberOfPagesArray: Array,
        currentPageNo: Number,
        pageSize: Number,
        contendersList: Array,
    },
    watch: {
        currentPage(data) {
            this.$emit('setCurrentActivePage', data);
        },
        numberOfPagesArray(val) {
            this.totalPages = val.length;
        },
        currentPageNo(val) {
            this.currentPage = val;
        }
    },
    computed: {
        startPage() {

            if (this.currentPage === 1 || this.currentPage === 2) {
                return 1;
            }
     
            if (this.currentPage === this.totalPages || (this.currentPage + 1) === this.totalPages) { 
                return this.totalPages - this.maxVisibleButtons + 1;
            }

            return this.currentPage - 2;

        },

        endPage() {
            return Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages);
        },

        pages() {
            const range = [];

            for (let i = this.startPage; i <= this.endPage; i+= 1 ) {
                if (i >= 1) {
                    range.push(i);
                }
            }

            return range;
        },
    },
    methods: {
        setCurrentPage (pageNumber) {
            this.currentPage = pageNumber;
            this.message = 'Updating results';
        
            setTimeout(() => {
                this.message = `Results ${(this.currentPage * this.pageSize) - (this.pageSize - 1)} - ${this.totalPages === this.currentPage ? this.contendersList.length : (this.currentPage * this.pageSize)} of ${this.contendersList.length} for nominees`;
            }, 500);
        },
        setPreviousPage() {
            const previousPage = this.currentPage - 1;
            this.setCurrentPage(previousPage);
        },
        setNextPage() {
            const nextPage = this.currentPage + 1;
            this.setCurrentPage(nextPage);
        }
    },
    mounted() {
        this.totalPages = this.numberOfPagesArray.length;
        this.currentPage = this.currentPageNo;
    }
}
</script>



// WEBPACK FOOTER //
// src/app/components/contestant-grid-pagination.vue